<template>
  <v-app>
    <v-main>
      <v-container container--fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-spacer></v-spacer>
              <div class="text-center avatar-header">
                <div class="private-register-logo-wrap">
                  <img :src="logoPrimary" alt="Kobe" />
                </div>
              </div>
              <v-spacer></v-spacer>
              <v-card-text>
                <p class="title">Register using your information below :</p>
                <v-form>
                  <v-text-field
                    v-model="registerUser.firstName"
                    :error-messages="nameErrors"
                    @input="$v.registerUser.firstName.$touch()"
                    @blur="$v.registerUser.firstName.$touch()"
                    prepend-icon="person"
                    name="firstName"
                    label="First Name"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="registerUser.lastName"
                    prepend-icon="person"
                    name="lastName"
                    label="Last Name"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="registerUser.email"
                    :error-messages="registerEmailErrors"
                    @input="$v.registerUser.email.$touch()"
                    @blur="$v.registerUser.email.$touch()"
                    prepend-icon="email"
                    name="email"
                    disabled
                    label="Email"
                    type="email"
                  ></v-text-field>
                  <v-text-field
                    v-model="registerUser.igHandle"
                    prepend-icon="mdi-instagram"
                    name="instagram"
                    :disabled="disableIgHandle"
                    label="Instagram Account Name"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="registerUser.tiktokHandle"
                    prepend-icon="fab fa-tiktok"
                    name="tiktok"
                    :disabled="disableTikTokHandle"
                    label="TikTok Account Name"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="registerUser.youtubeHandle"
                    prepend-icon="fab fa-youtube"
                    name="youtube"
                    :disabled="disableYoutubeHandle"
                    label="Youtube Account Name"
                    type="text"
                  ></v-text-field>
                  <v-combobox
                    prepend-icon="my_location"
                    v-model="registerUser.location"
                    :items="locations"
                    label="Select your location"
                  ></v-combobox>
                  <v-text-field
                    v-model="registerUser.password"
                    :error-messages="registerPasswordErrors"
                    @input="$v.registerUser.password.$touch()"
                    @blur="$v.registerUser.password.$touch()"
                    @keyup.enter="registerInfluencer()"
                    id="regPassword"
                    prepend-icon="lock"
                    name="regPassword"
                    label="Password"
                    type="password"
                  ></v-text-field>
                  <v-btn
                    :disabled="$v.registerUser.$invalid"
                    block
                    @click="registerInfluencer()"
                    color="secondary"
                  >Register</v-btn>
                  <v-divider></v-divider>
                  <p class="text-xs-left">
                    By Signing up, you confirm that you have read the
                    <a
                      href="https://www.getkobe.com/influencer-terms-use-agreement/"
                      target="_blank"
                    >terms and conditions</a> , that you understand them and that you agree to be bound by them.
                  </p>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <v-footer dark height="auto" color="#1A1A1A">
      <v-layout row wrap white--text text-center>
        <v-flex md4 xs12>
          <p class="white--text text-center">
            <u>Singapore</u>
            <br />Contact:
            <a href="tel:+6562555662">6255 5662</a> /
            <a href="mailto:contact@getkobe.com">CONTACT@GETKOBE.COM</a>
            <br />75 Ayer Rajah Crescent #01-09/10 Singapore 139953
          </p>
        </v-flex>
        <v-flex md4 xs12>
          <p class="white--text text-center">
            <br />Website
            <a href="https://getkobe.com/website-terms-use">Terms of Use</a> and
            <a href="https://getkobe.com/website-privacy-policy">Privacy Policy</a>.
            <br />All Rights Reserved &copy; 2016-{{year}} Kobe Global Technologies Pte Ltd
          </p>
        </v-flex>
        <v-flex md4 xs12>
          <p class="white--text text-center">
            <u>Malaysia / Thailand / Indonesia</u>
            <br />Contact:
            <a href="mailto:international@getkobe.com">INTERNATIONAL@GETKOBE.COM</a>
          </p>
        </v-flex>
      </v-layout>
    </v-footer>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="#A3FF12"
      width.number="90"
      height.number="90"
    />
  </v-app>
</template>
<script>
// import KFooter from '../components/core/Footer';
import userAPIs from './views/User/userAPIs';
import api from '@/api';
import { validationMixin } from 'vuelidate';
import countries from '../../static/sources/countries';
import { required, email } from 'vuelidate/lib/validators';
import Loading from 'vue-loading-overlay';
// import { regex } from 'vuelidate/lib/validators/common';
// const validPassword = regex('validPassword', config.regexPattern.password); // lowercase
export default {
  name: 'PrivateRegister',
  mixins: [validationMixin],
  components: {
    // KFooter,
    Loading
  },
  data() {
    return {
      registerUser: {
        firstName: '',
        lastName: '',
        email: '',
        location: '',
        password: '',
        igHandle: '',
        tiktokHandle: '',
        youtubeHandle: '',
        platform: '',
        role: 5, // default to Influencer
        activated: 0 // default to NotActivated
      },
      logoPrimary: require('@/assets/Kobe Logo Blue.png'),
      disableIgHandle: false,
      disableTikTokHandle: false,
      disableYoutubeHandle: false,
      locations: [],
      loading: false
    };
  },
  validations: {
    registerUser: {
      firstName: { required },
      email: { required, email },
      password: { required },
      // igHandle: { required },
      // tiktokHandle: { required },
      platform: { required }
    }
  },
  methods: {
    getLocations() {
      this.locations = countries.map(element => element.name);
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
    registerInfluencer() {
      // to-do implement registration for Influencer
      if (!this.registerUser.igHandle && !this.registerUser.tiktokHandle && !this.registerUser.youtubeHandle) {
        this.$swal({
          title: 'Invalid',
          text: 'Please enter Instagram, TikTok or Youtube Handle',
          type: 'warning'
        })
        return;
      }
      this.toggleLoading();
      const user = Object.assign({}, this.registerUser);
      // Add user
      var headers = {
        'K-Token': this.$route.query.token
      };
      api
        .request('post', '/api/v1/users/register', false, user, headers)
        .then(response => {
          this.toggleLoading();
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'Your account is registered! You will be redirected to login page.',
            type: 'success'
          }).then(() => {
            // New influencer email notification to CO's
            api.request('post', '/api/v1/posts/influencer/notify', false, user, headers);
            window.location = '/';
          });
        })
        .catch(error => {
          this.toggleLoading();
          console.log('Error: ' + error);
          // Show error message
          this.$swal({
            title: 'Sorry',
            text: error.response.data.message || 'Something went wrong! Please try again! (or) Contact Us for Help',
            type: 'error'
          });
        });
    }
  },
  beforeCreate() {
    let token = this.$route.query.token;
    // Validate token

    userAPIs
      .validatRegisterToken(token)
      .then(resp => {
        this.registerUser.email = resp.data.email.trim();
        this.registerUser.igHandle = resp.data.igHandle.trim();
        this.registerUser.tiktokHandle = resp.data.tiktokHandle.trim();
        this.registerUser.youtubeHandle = resp.data.youtubeHandle.trim();
        this.registerUser.platform = this.registerUser.igHandle ? 'instagram' : resp.data.platform.trim();
        if (this.registerUser.igHandle) this.disableIgHandle = true
        if (this.registerUser.tiktokHandle) this.disableTikTokHandle = true
        if (this.registerUser.youtubeHandle) this.disableYoutubeHandle = true
      })
      .catch(() => {
        this.$swal({
          title: 'Sorry',
          text: 'Your link is expired',
          type: 'error'
        }).then(() => {
          window.location = '/';
        });
      });
  },
  mounted() {
    this.getLocations();
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.registerUser.firstName.$dirty) return errors;
      !this.$v.registerUser.firstName.required && errors.push('FirstName is required');
      return errors;
    },
    registerEmailErrors() {
      const errors = [];
      if (!this.$v.registerUser.email.$dirty) return errors;
      !this.$v.registerUser.email.email && errors.push('Must be valid e-mail');
      !this.$v.registerUser.email.required && errors.push('E-mail is required');
      return errors;
    },
    registerPasswordErrors() {
      const errors = [];
      if (!this.$v.registerUser.password.$dirty) return errors;
      !this.$v.registerUser.password.required && errors.push('Password is required');
      return errors;
    },
    igHandleErrors() {
      const errors = [];
      if (!this.$v.registerUser.igHandle.$dirty) return errors;
      !this.$v.registerUser.igHandle.required && errors.push('Instagram account name is required');
      return errors;
    },
    showAccountName() {
      if (this.registerUser.platform === 'tiktok') {
        return 'TikTok Account Name'
      }
      return 'Instagram Account Name'
    }
  }
};
</script>
<style >
.avatar-header {
  background-color: #282b30;
  border-radius: 4px;
}

.private-register-logo-wrap {
  width: min(260px, 72vw);
  max-width: 260px;
  margin: 0 auto;
  line-height: 0;
}

.private-register-logo-wrap img {
  display: block;
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// PrivateRegister.vue?38ed7ccd